import {combineEpics} from 'redux-observable-es6-compat';
import {of, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {ALogout, ASetMessage} from '../actions';

import {listenPlayerEpic, pingEpic, playerEpic, playerSyncEpic, playFromContextEpic, setVolumeEpic, slideVolumeEpic} from './player.epic';
import {fetchRemotesEpic, setRemoteEpic} from './remote.epic';
import {dislikeEpic, fetchWishlistEpic, likeEpic} from './wishlist.epic';
import {createPlaylistEpic, fetchFamiliesEpic} from './family.epic';
import {addFavoriteEpic, fetchFavoritesEpic, removeFavoriteEpic} from './favorite.epic';
import {fetchPlaylistFromFamiliesEpic, fetchPlaylistFromLibraryEpic, fetchPlaylistsEpic, fetchTemposEpic} from './playlist.epic';
import {duplicateOneDayEpic, editScheduleEpic, fetchSchedulesEpic} from './schedule.epic';
import {addBlacklistEpic, fetchBlacklistEpic, removeBlacklistEpic} from './blacklist.epic';
import {fetchHistoryEpic} from './history.epic';
import {loginDesktopEpic, loginEpic, logoutEpic} from './user.epic';
import {fetchResortsEpic} from './resort.epic';
import {fetchHistoriesEpic} from './histories.epic';
import {fetchPlaylistMwEpic} from './playlist-mw.epic';
import {GetAudioDevicesEpic, SetAudioDeviceEpic} from './audio-device.epic';
import {fetchPlayrulesEpic} from './playrule.epic';
import {fetchUserParamsEpic} from './user-params.epic';
// import {fetchProviderEpic} from './provider.epic';

const allEpics = [
  playerEpic,
  playerSyncEpic,
  playFromContextEpic,
  likeEpic,
  dislikeEpic,
  fetchWishlistEpic,
  addFavoriteEpic,
  removeFavoriteEpic,
  fetchFavoritesEpic,
  fetchFamiliesEpic,
  createPlaylistEpic,
  fetchPlaylistMwEpic,
  fetchTemposEpic,
  fetchPlaylistsEpic,
  // fetchProviderEpic,
  fetchRemotesEpic,
  listenPlayerEpic,
  setRemoteEpic,
  fetchSchedulesEpic,
  fetchBlacklistEpic,
  removeBlacklistEpic,
  addBlacklistEpic,
  fetchHistoryEpic,
  fetchHistoriesEpic,
  loginEpic,
  loginDesktopEpic,
  fetchResortsEpic,
  slideVolumeEpic,
  logoutEpic,
  fetchPlaylistFromLibraryEpic,
  fetchPlaylistFromFamiliesEpic,
  setVolumeEpic,
  pingEpic,
  SetAudioDeviceEpic,
  GetAudioDevicesEpic,
  duplicateOneDayEpic,
  editScheduleEpic,
  fetchPlayrulesEpic,
  fetchUserParamsEpic
].map(epic => (a, s, d) => epic(a, s, d).pipe(
  catchError(err => {
    if (err.status === 401) {
      return of(ALogout());
    } else if (err.status && err.message) {
      return of(ASetMessage(''));
    }
    if (err.status === 404) {
      return of(ASetMessage('Not Found'));
    }
    console.error(err);
    return throwError(new Error(err));
  })
));
export const rootEpic = combineEpics(...allEpics);
